import React from 'react';
import ContestUploadComponent from '../Component/ContestUploadComponent';

export default function ContestUploadContainer() {
  return <ContestUploadComponent />;
}
